import React, { PureComponent, memo } from 'react';
import { toDDHHMMSS } from '../../Util/Util';

class TimeLabel extends PureComponent {
    timer = null;
    _isMounted = false;

    state = {
        labelTiempo: '',
    }

    componentDidMount() {
        this._isMounted = true;
        this.startInterval();
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.stopInterval();
    }

    componentDidUpdate(prevProps) {
        if (this.props.activo !== prevProps.activo ||
            this.props.tiempo !== prevProps.tiempo ||
            this.props.cambioDireccion !== prevProps.cambioDireccion ||
            this.props.estado !== prevProps.estado) {
            this.stopInterval();
            this.startInterval();
        }
    }

    startInterval = () => {
        let _segundos = this.props.tiempo;
        if (this.props.activo) {
            if (this.props.cambioDireccion) {
                let esNegativo = _segundos < 0;
                _segundos = esNegativo ? _segundos * -1 : _segundos;

                this.timer = setInterval(() => {
                    if (esNegativo) {
                        _segundos += 1;
                    }
                    else {
                        _segundos -= 1;
                    }

                    if (_segundos == 0) {
                        this.props.estado = 'delay';
                        this._isMounted && this.setState({ labelTiempo: toDDHHMMSS(_segundos) });
                        esNegativo = true;
                    }
                    else {
                        this._isMounted && this.setState({ labelTiempo: toDDHHMMSS(_segundos) });
                    }
                }, 1000);
            }
            else {
                this.timer = setInterval(() => {
                    _segundos += 1;
                    this._isMounted && this.setState({ labelTiempo: toDDHHMMSS(_segundos) });
                }, 1000);
            }
        } else {
            this._isMounted && this.setState({ labelTiempo: toDDHHMMSS(_segundos) });
        }
    }

    stopInterval= () => {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    }

    render() {
        return (<label className={"time-" + this.props.estado}>{this.state.labelTiempo}</label>)
    }
};

export default memo(TimeLabel); 
